import { default as indexAUK4ANxb48Meta } from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/about/index.vue?macro=true";
import { default as indexSlc8IgA1aTMeta } from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/career/index.vue?macro=true";
import { default as indexxXNctmOBLRMeta } from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/contacts/index.vue?macro=true";
import { default as index7o7FFvFP7CMeta } from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/documents/index.vue?macro=true";
import { default as indexcYydFeWafKMeta } from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/index.vue?macro=true";
import { default as indexXBouZjHH47Meta } from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/news/index.vue?macro=true";
import { default as _91slug_93DLZMgio8cTMeta } from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/services/[slug].vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/about/index.vue")
  },
  {
    name: "about___ru",
    path: "/about",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/about/index.vue")
  },
  {
    name: "career___en",
    path: "/en/career",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/career/index.vue")
  },
  {
    name: "career___ru",
    path: "/career",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/career/index.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/contacts/index.vue")
  },
  {
    name: "contacts___ru",
    path: "/contacts",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/contacts/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/documents/index.vue")
  },
  {
    name: "documents___ru",
    path: "/documents",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/documents/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/news",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/news/index.vue")
  },
  {
    name: "services-slug___en",
    path: "/en/services/:slug()",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/services/[slug].vue")
  },
  {
    name: "services-slug___ru",
    path: "/services/:slug()",
    component: () => import("/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/pages/services/[slug].vue")
  }
]